import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ENTORNO } from "../../utils/constantes";
import {
  setToken,
  setemail,
  setpassword,
  setusuarioPerfil,
  setrole,
  setid,
  setNombre,
  setApellido,
  setTelefono,
  setLocalidad,
  setContactosEmergencia,
  setLatitudGPS,
  setLongitudGPS,
  setLatitudIP,
  setLongitudIP,
} from "../../utils/variablesLocales";

export function CerrarSesion() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        setToken(null);
        setemail(null);
        setpassword(null);
        setusuarioPerfil(null);
        setrole(null);
        setid(null);
        setusuarioPerfil(null);

        setNombre(null);
        setApellido(null);
        setTelefono(null);
        setLocalidad(null);

        setContactosEmergencia(null);

        setLatitudGPS(null);
        setLongitudGPS(null);

        setLatitudIP(null);
        setLongitudIP(null);

        navigate(ENTORNO.URL_APLICACION + "/Ingresar");
      } catch (error) {
        console.log(error);
      }
    })();
  });

  return <div></div>;
}
